// extracted by mini-css-extract-plugin
export default {"fsCampaignFooter":"abtasty-qa-assistant__FsCampaignFooter-module__fsCampaignFooter___Y7J1u","btn":"abtasty-qa-assistant__FsCampaignFooter-module__btn____hPuM"};